import  gql  from 'graphql-tag'

export const CREATE_REGIONAL = gql`mutation regional($input: RegionalMutationInput!){
    regional(input: $input){
        regional{
            id
            code
            name
            isActive
        }
        errors{
            field
            messages
        }
    }
}`;